import AjaxLoad from './../../components/ajax-load/ajax-load';
import { initMasonry } from '../../utilities/js/masonry';

class Pagination {
    constructor (element, options) {
        this.$pagination = element;
        this.$itemFirst = document.querySelector('[data-feed-item-first]');

        const settings = {
            onSubmitted: null,
            content: this.$pagination.querySelector('[data-pagination="content"]')
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$page = this.$pagination.querySelectorAll('[data-pagination="page"]');

        for (let i = 0; i < this.$page.length; i++) {
            this.$page[i].addEventListener('click', (event) => {
                event.preventDefault();

                this.setPage(this.$page[i].href);
            });
        }
    }

    setPage (uri) {
        new AjaxLoad(uri, { // eslint-disable-line
            onSuccess: (resultText) => {
                this.settings.content.innerHTML = '';

                if (resultText) {
                    this.settings.content.innerHTML = resultText;

                    const contentUpdateEvent = new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: document
                        }
                    });

                    window.dispatchEvent(contentUpdateEvent);
                    this.setEvents();
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted(this.$pagination);
                }

                if (window.innerWidth > 1024 && this.$itemFirst) {
                    setTimeout(() => {
                        this.initMasonry();
                    }, 500);
                }
            }
        });
    }

    initMasonry () {
        const $itemWidth = this.$itemFirst.clientWidth + parseInt(getComputedStyle(this.$itemFirst).marginRight);
        /* eslint-disable */
        const $masonry = initMasonry($itemWidth);
    }
}

export { Pagination };
